<template>
  <icon-svg-base
    :view-width="20"
    :view-height="20"
    class="icon"
  >
    <path
      :stroke-width="strokeWidth"
      d="M 2 5 L 2 14 L 18 14"
      transform="translate(0 -3) rotate(-45, 10, 10)"
      class="icon__stroke"
    />
    />
  </icon-svg-base>
</template>

<script>
import IconSvgBase from '@/mikan/_shared/components/atoms/icons/IconSvgBase.vue';

export default {
  components: {
    IconSvgBase,
  },
  props: {
    strokeWidthRatio: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    strokeWidth() {
      return 3 * this.strokeWidthRatio;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.icon {
  width: 1em;
  height: 1em;

  &__stroke {
    fill: transparent;
    stroke: currentColor;
  }
}
</style>
